<template>
  <SectionContentLayout
    content_class="contacts-import">
    <template #close>
      <ActionButton
          @click='close()'
          v-tooltip='"contacts.actions.close"'
          class="close"
          icon="fas fa-times-circle"
        />
    </template>

    <template #header>
        <ContentTitle title="contacts.import.title"/>
    </template>

    <template #content>
      <div class="form">
          <fieldset>
              <p>{{ Language.say('contacts.import.description') }}</p>

              <div class="control-group">
                  <div class="control file-upload">
                      <label for="contactsFileUpload">
                          <input id="contactsFileUpload" type="file" @change="onEventFilePicked">
                          <span>{{ Language.say('contacts.import.action_select_file') }}</span>
                          <strong>
                              <i class="fas fa-upload"></i>
                              {{ Language.say('contacts.import.action_select_file') }}
                          </strong>
                      </label>
                  </div>
              </div>
          </fieldset>

        </div>
    </template>
  </SectionContentLayout>
</template>

<script setup>
  import { defineEmits  } from 'vue'
  import { useRouter }        from 'vue-router';
  import SectionContentLayout from '@/vue/Layouts/Sections/SectionContentLayout.vue';
  import Language from '@/js/Shared/Language/Language';
  import ActionButton from '@/vue/Elements/Buttons/ActionButton.vue';
  import ContentTitle from '@/vue/Elements/Content/ContentTitle.vue';

  const props = defineProps({
    contacts_import_controller: {},
  });

  const emit = defineEmits([
    'onFileRead',
  ]);

  const router         = useRouter();

  const onEventFilePicked = (event) => {
    const files = event.target.files;
    const reader = new FileReader();

    reader.addEventListener('load', () => {
        if(!props.contacts_import_controller.validateFile(files[0].type, files[0].size)){
          return;
        }

        setFields(reader.result, files[0].type);
    })

    reader.readAsDataURL(files[0])
  }

  const setFields = (contact_list_blob, mime_type) => {
    if(!props.contacts_import_controller.createContactsCollection(contact_list_blob, mime_type)){
      return;
    }

    emit('onFileRead');
  }

  const close = () => {
    router.push('/contacts');
  }
</script>